/* eslint-disable no-unused-vars */
import {
  TimelineMax,
  Power2
} from 'gsap'
import ScrollToPlugin from 'gsap/ScrollToPlugin'
import store from '../data/store'
import _ from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import trackList from '../components/Tracks'
const setCount = {
  count: 0
}
let audio = new Audio(),
  checkState = (currentIndex, v, i) => {
    if (i !== currentIndex) {
      v.active = false;
    }
  }
export default {
  name: 'searchResults',
  components: {
    VuePerfectScrollbar,
    'track-list': trackList
  },
  data() {
    return {
      settings: {
        maxScrollbarLength: 60
      }
    }
  },
  computed: {
    searchType () {
      return store.state.searchType !== 'artist'
    }
  },
  mounted() {
    this.tl = new TimelineMax({
      onComplete: this.dispalyResultsDone,
      paused: true
    })
    this.tlOut = new TimelineMax({})
  },
  beforeUpdate() {
    this.tl.clear()
    this.tlOut.clear()
  },
  methods: {
    toggleClass(album, i) {
      if (store.state.searchType !== 'artist' && album.mbid !== '') {
        store.state.tracks = [];
        album.active = !album.active
        store.dispatch('getTracks', {
          mbid: album.mbid,
          index: i
        });

        _.forEach(store.state.searchResults, _.bind(checkState, this, i))
      }
    },
    dispalyResultsDone() {
      setCount.count = 0
    },
    enterEl(el) {
      setCount.count++

        this.tl.fromTo(el, 0.5, {
          opacity: 0
        }, {
          opacity: 1,
          delay: .5
        }, 'searchResultsIn')

      if (setCount.count === store.state.total || setCount.count === store.state.limit) {
        if (store.state.offset > 0) {
          let offsetSong = document.querySelectorAll('.search-results').item(store.state.offset).offsetTop

          this.tl.to(window, 0.5, {
            scrollTo: {
              y: offsetSong - 10
            },
            ease: Power2.easeInOut
          }, 'searchResultsIn')
        }

        this.tl.play()
      }
    },
    leaveEl(el, done) {
      this.tlOut.to(el, .5, {
        opacity: 0,
        onComplete: done
      }, 'searchResultsOut')
    },
    loadMore() {
      store.dispatch('search', {
        tearm: store.state.searchTearm,
        type: 'loadMore'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mv/search-results.js